<div class="ParentSectionSection_Components_HTally">
  <div class="HeaderTop_Dashboard" [class.has-calendar]="showDashboardMonthControl && showMonthControl" [ngStyle]="desktopHeaderRowStyle">
    <div class="HeaderTop_Left">
      <div class="TopHeader_PageTitleWrap" [ngStyle]="desktopHeaderLeftStyle">
        <div class="TopHeader_PageTitle">{{ resolvedPageTitle | t:resolvedPageTitle }}</div>
        <button
          type="button"
          class="TopHeader_InfoBtn"
          *ngIf="showPageInfoButton"
          [attr.aria-label]="'topHeader.pageInfo' | t:'Page info'"
          (click)="onPageInfoClick($event)"
        >i</button>
      </div>
    </div>
    <div class="HeaderTop_Center">
      <div class="Calendar_HeaderTop_Dashboard" *ngIf="showDashboardMonthControl && showMonthControl" [ngStyle]="desktopHeaderCenterStyle">
        <label (click)="openCalendarModal()">
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 11.4399H22V16.9999C22 19.7614 19.7614 21.9999 17 21.9999H5C2.23858 21.9999 0 19.7614 0 16.9999V11.4399Z" />
            <path d="M0 5.87988C0 3.11846 2.23858 0.879883 5 0.879883H17C19.7614 0.879883 22 3.11846 22 5.87988V9.67988H0V5.87988Z" />
            <ellipse cx="7.24992" cy="5.03992" rx="2.25004" ry="2.16004" fill="white" />
            <rect x="6.49939" width="1.50003" height="5.04" rx="0.750014" fill="white" />
            <ellipse cx="14.7491" cy="5.03992" rx="2.25004" ry="2.16004" fill="white" />
            <rect x="13.9996" width="1.50003" height="5.04" rx="0.750014" fill="white" />
          </svg>
          <span (click)="openCalendarModal()">{{ months[selectedMonth] | t:months[selectedMonth] }}, {{ selectedYear }}</span>
          <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.13229 4.5976C4.44623 4.23136 4.75417 3.87219 5.06204 3.51292C5.70675 2.76065 6.35211 2.00893 6.9955 1.25552C7.13027 1.09769 7.29303 1.00564 7.50323 1.03008C7.71629 1.05484 7.87185 1.16816 7.95445 1.36919C8.03933 1.5758 8.00386 1.76808 7.8624 1.93674C7.6271 2.21723 7.38684 2.49356 7.14868 2.77168C6.29694 3.76638 5.44438 4.7604 4.59427 5.75642C4.43599 5.94186 4.24572 6.04925 4.00431 5.97761C3.8913 5.94407 3.77243 5.87174 3.69579 5.78286C2.58728 4.49773 1.48494 3.20718 0.382493 1.91681C0.174636 1.67348 0.202562 1.3294 0.440034 1.13134C0.683401 0.928412 1.01434 0.963302 1.23226 1.21753C2.16853 2.30997 3.10411 3.40304 4.0401 4.49573C4.06754 4.52782 4.09678 4.55847 4.13229 4.5976Z" />
          </svg>
        </label>

        <div class="modal-overlay" *ngIf="isCalendarOpen" (click)="closeCalendarModal($event)">
          <div class="modal-content" (click)="$event.stopPropagation()">
            <span class="close-icon" (click)="closeByIcon()">&times;</span>
            <div class="calendar-picker-body">
              <label class="calendar-control">
                <span>{{ 'topHeader.month' | t:'Month' }}</span>
                <select [(ngModel)]="draftMonth">
                  <option *ngFor="let month of months; let i = index" [ngValue]="i">{{ month | t:month }}</option>
                </select>
              </label>
              <label class="calendar-control">
                <span>{{ 'topHeader.year' | t:'Year' }}</span>
                <select [(ngModel)]="draftYear">
                  <option *ngFor="let year of availableYears" [ngValue]="year">{{ year }}</option>
                </select>
              </label>
              <button type="button" class="calendar-apply-btn" (click)="applyDraftMonth()">{{ 'topHeader.apply' | t:'Apply' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="HeaderTop_Right">
      <div class="User_Notification_HeaderTop_Dashboard" [ngStyle]="desktopHeaderRightStyle" (click)="$event.stopPropagation()">
        <img [src]="userImage" (error)="onUserImageError()" (click)="openUserMenu($event)" />

        <div class="user-menu" *ngIf="isUserOptionOpen">
          <div class="menu-profile">
            <div class="menu-profile-image-wrap">
              <img [src]="userImage" (error)="onUserImageError()" alt="Profile" class="menu-profile-image" (click)="canManageProfileImage && openImageUpdateModal($event)" />
              <button *ngIf="canManageProfileImage" type="button" class="menu-profile-image-edit" aria-label="Edit image" (click)="openImageUpdateModal($event)">
                &#9998;
              </button>
            </div>
            <div class="menu-profile-meta">
              <div class="menu-profile-name">{{ profile?.organizationName || profile?.name || ('common.user' | t:'User') }}</div>
              <div class="meta" *ngIf="profile?.organizationName && profile?.name">{{ profile?.name }}</div>
              <div class="meta">{{ profile?.username || ('common.na' | t:'N/A') }}</div>
              <div class="meta">{{ profile?.mobileNumber || ('common.na' | t:'N/A') }}</div>
            </div>
            <div class="menu-profile-tools">
              <div class="menu-preference-row">
                <div class="menu-preference-copy">
                  <span class="menu-preference-label">{{ 'common.language' | t:'Language' }}</span>
                  <span class="menu-preference-hint">{{ 'topHeader.languagePreferenceHint' | t:'Choose app language' }}</span>
                </div>
                <app-language-switch class="menu-language-switch" [compact]="true"></app-language-switch>
              </div>

              <div *ngIf="showStorageUsage" class="menu-storage-card">
                <div class="menu-storage-line">
                  <span class="menu-storage-title">{{ 'common.storage' | t:'Storage' }}</span>
                  <span class="menu-storage-percent">{{ storageUsagePercentLabel }}</span>
                </div>
                <div class="menu-storage-text">{{ formatStorage(usageSummary?.usage?.usedFileSize) }} / {{ formatStorage(totalStorageBytes) }}</div>
                <div class="menu-storage-bar">
                  <span class="menu-storage-fill" [style.width.%]="storageUsagePercent"></span>
                </div>
                <div *ngIf="packageExpireDateLabel" class="menu-storage-expire-wrap">
                  <span class="menu-storage-expire-title">{{ 'subscription.packageExpireDate' | t:'Package Expire Date' }}</span>
                  <span class="menu-storage-expire-value">{{ packageExpireDateLabel }}</span>
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="menu-btn" (click)="openProfileEditModal($event)">{{ profileEditButtonLabel | t:profileEditButtonLabel }}</button>
          <button type="button" class="menu-btn logout" (click)="logout($event)">{{ 'topHeader.logout' | t:'Logout' }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="modal-overlay profile-overlay" *ngIf="isImageUpdateModalOpen && canManageProfileImage" (click)="closeImageUpdateModal()">
    <div class="image-update-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeImageUpdateModal($event)">&times;</button>
      <h3>{{ 'topHeader.updateOrganizationLogo' | t:'Update Organization Logo' }}</h3>
    <div class="image-update-body">
        <img [src]="userImage" alt="Profile image" class="image-update-preview" />
        <label class="upload-image-btn" *ngIf="canManageProfileImage">
          <input type="file" accept=".jpg,.jpeg,.png" (change)="onProfileImageSelected($event)" [disabled]="isUploadingImage" />
          {{ isUploadingImage ? ('common.uploading' | t:'Uploading...') : ('common.changeLogo' | t:'Change Logo') }}
        </label>
        <div class="upload-rules">{{ 'topHeader.allowed' | t:'Allowed' }}: {{ allowedImageExtensionsText }}</div>
        <div class="profile-message error" *ngIf="profileError">{{ profileError }}</div>
      <div class="profile-message success" *ngIf="profileSuccess">{{ profileSuccess }}</div>
      </div>
    </div>
  </div>

  <app-image-crop-modal
    [visible]="!!profileImageCropSourceFile"
    [sourceFile]="profileImageCropSourceFile"
    [title]="'topHeader.cropOrganizationImage' | t:profileImageCropTitle"
    [hint]="'topHeader.cropOrganizationImageHint' | t:profileImageCropHint"
    [outputHint]="'topHeader.cropOutputHint' | t:'The cropped image will be saved as JPG to reduce upload size.'"
    [confirmLabel]="'common.useCroppedImage' | t:'Use Cropped Image'"
    [cancelLabel]="'common.cancel' | t:'Cancel'"
    fallbackBaseName="organization-image"
    (cancel)="onProfileImageCropCancelled()"
    (confirm)="onProfileImageCropped($event)"
  ></app-image-crop-modal>

  <div class="modal-overlay profile-overlay" *ngIf="isProfileEditModalOpen" (click)="closeProfileEditModal()">
    <div class="profile-edit-modal" (click)="$event.stopPropagation()">
    <button class="close-icon" type="button" [attr.aria-label]="'common.close' | t:'Close'" (click)="closeProfileEditModal($event)">&times;</button>
    <h3>{{ profileEditModalTitle | t:profileEditModalTitle }}</h3>
    <div class="profile-autofill-guard" aria-hidden="true">
      <input type="text" name="fake_username" autocomplete="username" tabindex="-1" />
      <input type="password" name="fake_password" autocomplete="new-password" tabindex="-1" />
    </div>
    <div class="profile-sections-grid">
    <div class="profile-section profile-section-wide" *ngIf="canShowFullProfileEdit">
      <div class="profile-section-head">
        <div class="profile-section-title">{{ 'topHeader.basic' | t:'Basic' }}</div>
      </div>
      <div class="profile-edit-grid">
        <label class="profile-field">
          <span>{{ 'topHeader.fullName' | t:'Full Name' }}</span>
          <input type="text" [(ngModel)]="basicInfoForm.name" [placeholder]="'placeholder.typeFullName' | t:'Type full name'" />
        </label>
        <label class="profile-field">
          <span>{{ 'topHeader.organizationName' | t:'Organization/Housing Name' }}</span>
          <input type="text" [(ngModel)]="basicInfoForm.organizationName" [placeholder]="'placeholder.typeOrganizationName' | t:'Type organization/housing name'" />
        </label>
        <label class="profile-field profile-field-full">
          <span>{{ 'topHeader.mobileNumber' | t:'Mobile Number' }}</span>
          <span class="profile-mobile-input-wrap">
            <span class="profile-mobile-prefix">{{ mobilePrefix }}</span>
            <input
              type="tel"
              inputmode="numeric"
              [(ngModel)]="basicInfoForm.mobileNumber"
              [placeholder]="'placeholder.typeMobileNumber' | t:'Type mobile number'"
              (blur)="normalizeBasicInfoMobile()"
            />
          </span>
        </label>
      </div>
      <div class="profile-modal-actions">
        <button type="button" class="profile-save-btn" [disabled]="isSavingBasicInfo" (click)="saveBasicInfo()">
          {{ isSavingBasicInfo ? ('common.saving' | t:'Saving...') : ('topHeader.saveBasicInfo' | t:'Save Basic Info') }}
        </button>
      </div>
      <div class="profile-message error" *ngIf="basicInfoError">{{ basicInfoError }}</div>
      <div class="profile-message success" *ngIf="basicInfoMessage">{{ basicInfoMessage }}</div>
    </div>

    <div class="profile-section">
      <div class="profile-section-head">
        <div class="profile-section-title">{{ 'topHeader.password' | t:'Password' }}</div>
      </div>
      <div class="profile-edit-grid profile-password-grid">
        <label class="profile-field">
          <span>{{ 'topHeader.currentPassword' | t:'Current Password' }}</span>
          <span class="profile-password-input-wrap">
            <input [type]="showCurrentPassword ? 'text' : 'password'" [(ngModel)]="passwordUpdateForm.currentPassword" [placeholder]="'placeholder.typeCurrentPassword' | t:'Type current password'" autocomplete="new-password" data-lpignore="true" />
            <button type="button" class="profile-password-toggle inside" (click)="toggleCurrentPasswordVisibility()" [attr.aria-label]="showCurrentPassword ? ('topHeader.hideCurrentPassword' | t:'Hide current password') : ('topHeader.showCurrentPassword' | t:'Show current password')">
              <svg *ngIf="!showCurrentPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5C6.5 5 2.12 8.44 1 12c1.12 3.56 5.5 7 11 7s9.88-3.44 11-7c-1.12-3.56-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"></path>
              </svg>
              <svg *ngIf="showCurrentPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2.7 1.29L1.29 2.7l4 4C3.52 8.03 2.14 9.86 1 12c1.12 3.56 5.5 7 11 7c2.3 0 4.38-.6 6.12-1.62l3.17 3.17l1.41-1.41L2.7 1.29ZM12 17c-3.98 0-7.14-2.27-8.56-5c.74-1.42 1.87-2.7 3.28-3.63l1.53 1.53A4 4 0 0 0 14.1 15.75l1.56 1.56c-1.08.43-2.3.69-3.66.69Zm0-10c3.98 0 7.14 2.27 8.56 5c-.53 1.03-1.28 1.99-2.19 2.8l-1.43-1.43A4 4 0 0 0 10.63 7.6L9.01 5.98c.93-.31 1.93-.48 2.99-.48Z"></path>
              </svg>
            </button>
          </span>
        </label>
        <label class="profile-field">
          <span>{{ 'topHeader.newPassword' | t:'New Password' }}</span>
          <span class="profile-password-input-wrap">
            <input [type]="showNewPassword ? 'text' : 'password'" [(ngModel)]="passwordUpdateForm.newPassword" [placeholder]="'placeholder.typeNewPassword' | t:'Type new password'" autocomplete="new-password" data-lpignore="true" />
            <button type="button" class="profile-password-toggle inside" (click)="toggleNewPasswordVisibility()" [attr.aria-label]="showNewPassword ? ('topHeader.hideNewPassword' | t:'Hide new password') : ('topHeader.showNewPassword' | t:'Show new password')">
              <svg *ngIf="!showNewPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5C6.5 5 2.12 8.44 1 12c1.12 3.56 5.5 7 11 7s9.88-3.44 11-7c-1.12-3.56-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"></path>
              </svg>
              <svg *ngIf="showNewPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2.7 1.29L1.29 2.7l4 4C3.52 8.03 2.14 9.86 1 12c1.12 3.56 5.5 7 11 7c2.3 0 4.38-.6 6.12-1.62l3.17 3.17l1.41-1.41L2.7 1.29ZM12 17c-3.98 0-7.14-2.27-8.56-5c.74-1.42 1.87-2.7 3.28-3.63l1.53 1.53A4 4 0 0 0 14.1 15.75l1.56 1.56c-1.08.43-2.3.69-3.66.69Zm0-10c3.98 0 7.14 2.27 8.56 5c-.53 1.03-1.28 1.99-2.19 2.8l-1.43-1.43A4 4 0 0 0 10.63 7.6L9.01 5.98c.93-.31 1.93-.48 2.99-.48Z"></path>
              </svg>
            </button>
          </span>
        </label>
        <label class="profile-field profile-field-full">
          <span>{{ 'topHeader.retypeNewPassword' | t:'Retype New Password' }}</span>
          <span class="profile-password-input-wrap">
            <input [type]="showConfirmNewPassword ? 'text' : 'password'" [(ngModel)]="passwordUpdateForm.confirmNewPassword" [placeholder]="'placeholder.retypeNewPassword' | t:'Retype new password'" autocomplete="new-password" data-lpignore="true" />
            <button type="button" class="profile-password-toggle inside" (click)="toggleConfirmNewPasswordVisibility()" [attr.aria-label]="showConfirmNewPassword ? ('topHeader.hideRetypePassword' | t:'Hide retype new password') : ('topHeader.showRetypePassword' | t:'Show retype new password')">
              <svg *ngIf="!showConfirmNewPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5C6.5 5 2.12 8.44 1 12c1.12 3.56 5.5 7 11 7s9.88-3.44 11-7c-1.12-3.56-5.5-7-11-7Zm0 11a4 4 0 1 1 0-8a4 4 0 0 1 0 8Z"></path>
              </svg>
              <svg *ngIf="showConfirmNewPassword" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M2.7 1.29L1.29 2.7l4 4C3.52 8.03 2.14 9.86 1 12c1.12 3.56 5.5 7 11 7c2.3 0 4.38-.6 6.12-1.62l3.17 3.17l1.41-1.41L2.7 1.29ZM12 17c-3.98 0-7.14-2.27-8.56-5c.74-1.42 1.87-2.7 3.28-3.63l1.53 1.53A4 4 0 0 0 14.1 15.75l1.56 1.56c-1.08.43-2.3.69-3.66.69Zm0-10c3.98 0 7.14 2.27 8.56 5c-.53 1.03-1.28 1.99-2.19 2.8l-1.43-1.43A4 4 0 0 0 10.63 7.6L9.01 5.98c.93-.31 1.93-.48 2.99-.48Z"></path>
              </svg>
            </button>
          </span>
        </label>
      </div>
      <div class="profile-modal-actions">
        <button type="button" class="profile-save-btn" [disabled]="isUpdatingPassword" (click)="updatePassword()">
          {{ isUpdatingPassword ? ('common.updating' | t:'Updating...') : ('topHeader.updatePasswordButton' | t:'Update Password') }}
        </button>
      </div>
      <div class="profile-message error" *ngIf="passwordUpdateError">{{ passwordUpdateError }}</div>
      <div class="profile-message success" *ngIf="passwordUpdateMessage">{{ passwordUpdateMessage }}</div>
    </div>

    <div class="profile-section profile-section-compact" *ngIf="canShowFullProfileEdit">
      <div class="profile-section-head">
        <div class="profile-section-title">{{ 'topHeader.email' | t:'Email' }}</div>
      </div>
      <div class="profile-edit-grid">
        <label class="profile-field profile-field-full">
          <span>{{ 'topHeader.newEmail' | t:'New Email' }}</span>
          <input type="email" [(ngModel)]="emailUpdateForm.newEmail" [placeholder]="'placeholder.typeNewEmail' | t:'Type new email'" autocomplete="off" autocapitalize="off" spellcheck="false" />
        </label>
      </div>
      <div class="profile-modal-actions profile-inline-actions">
        <button type="button" class="profile-send-otp-btn" [disabled]="isSendingNewEmailOtp" (click)="sendNewEmailOtp()">
          {{ isSendingNewEmailOtp ? ('signIn.forgot.sending' | t:'Sending...') : (newEmailOtpExpiresInSeconds === 0 && isEmailOtpSent ? ('topHeader.resendOtp' | t:'Resend OTP') : ('topHeader.sendOtp' | t:'Send OTP')) }}
        </button>
      </div>
      <div class="profile-edit-grid" *ngIf="isEmailOtpSent">
        <div class="profile-field profile-field-full profile-otp-field">
          <span>{{ 'topHeader.otp' | t:'OTP' }}</span>
          <input type="text" [(ngModel)]="emailUpdateForm.newEmailOtp" [placeholder]="'placeholder.typeOtpFromNewEmail' | t:'Type OTP from new email'" autocomplete="one-time-code" inputmode="numeric" />
          <div class="profile-otp-meta" *ngIf="newEmailOtpExpiresInSeconds > 0">{{ 'topHeader.otpExpiresIn' | t:'OTP expires in' }} {{ newEmailOtpExpireLabel }}</div>
          <div class="profile-otp-meta expired" *ngIf="newEmailOtpExpiresInSeconds === 0">{{ 'topHeader.otpExpired' | t:'OTP expired. Resend OTP.' }}</div>
        </div>
      </div>
      <div class="profile-modal-actions" *ngIf="isEmailOtpSent">
        <button type="button" class="profile-save-btn" [disabled]="isUpdatingEmail" (click)="updateEmail()">
          {{ isUpdatingEmail ? ('common.updating' | t:'Updating...') : ('topHeader.updateEmail' | t:'Update Email') }}
        </button>
      </div>
      <div class="profile-message error" *ngIf="emailUpdateError">{{ emailUpdateError }}</div>
      <div class="profile-message success" *ngIf="emailUpdateMessage">{{ emailUpdateMessage }}</div>
    </div>
    </div>
  </div>
</div>
